(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collezioni-mondo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-wc-prev], [data-wc-next]');
  if(!btn) return;
  var root = btn.closest('.worlds-carousel');
  if(!root) return;
  var track = root.querySelector('.worlds-carousel__track');
  if(!track) return;
  var card = track.querySelector('.world');
  var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
  var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
  var dir = btn.hasAttribute('data-wc-next') ? 1 : -1;
  track.scrollBy({ left: dir * step, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.google-reviews--carousel').forEach(function (root) {
  var track = root.querySelector('.google-reviews__grid--carousel');
  if (!track) return;
  var cards = track.querySelectorAll('.google-reviews__card');
  var dots = root.querySelectorAll('[data-gr-dot]');
  if (!dots.length) return;

  function setActive(index) {
    dots.forEach(function (dot, di) {
      dot.classList.toggle('is-active', di === index);
    });
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      var card = cards[i];
      if (!card) return;
      var left = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
    });
  });

  var ticking = false;
  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var trackLeft = track.getBoundingClientRect().left;
      var best = 0;
      var min = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (dist < min) { min = dist; best = i; }
      });
      setActive(best);
      ticking = false;
    });
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-spotight"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var roots = document.querySelectorAll('.vspot');
      roots.forEach(function (root) {
        if (root.dataset.vspotInit) return;
        root.dataset.vspotInit = '1';

        var INACTIVE_W = 210;
        var GAP = 16;
        var track = root.querySelector('[data-track]');
        var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
        var texts = Array.prototype.slice.call(root.querySelectorAll('[data-text]'));
        if (!track || !cards.length) return;
        var videos = cards.map(function (c) { return c.querySelector('[data-video]'); });
        var current = 0;
        var mq = window.matchMedia('(max-width: 768px)');

        function isMobile() { return mq.matches; }

        function positionDesktop(i) {
          var offset = i * (INACTIVE_W + GAP);
          track.style.transform = 'translateX(' + (-offset) + 'px)';
        }

        function setActive(i, userAction) {
          if (i < 0) i = 0;
          if (i > cards.length - 1) i = cards.length - 1;
          current = i;
          cards.forEach(function (c, idx) { c.classList.toggle('is-active', idx === i); });
          dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
          texts.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
          videos.forEach(function (v, idx) {
            if (!v) return;
            if (idx === i) {
              var p = v.play();
              if (p && p.catch) { p.catch(function () {}); }
            } else {
              try { v.pause(); v.currentTime = 0; } catch (e) {}
            }
          });
          if (isMobile()) {
            track.style.transform = '';
            if (userAction && cards[i].scrollIntoView) {
              cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          } else {
            positionDesktop(i);
          }
        }

        cards.forEach(function (c, idx) {
          c.addEventListener('click', function () { setActive(idx, true); });
        });
        dots.forEach(function (d, idx) {
          d.addEventListener('click', function () { setActive(idx, true); });
        });

        var scrollTimer;
        track.addEventListener('scroll', function () {
          if (!isMobile()) return;
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var center = track.scrollLeft + track.clientWidth / 2;
            var best = 0, bestDist = Infinity;
            cards.forEach(function (c, idx) {
              var cc = c.offsetLeft + c.clientWidth / 2;
              var d = Math.abs(cc - center);
              if (d < bestDist) { bestDist = d; best = idx; }
            });
            if (best !== current) setActive(best, false);
          }, 90);
        }, { passive: true });

        function onModeChange() { setActive(current, false); }
        if (mq.addEventListener) { mq.addEventListener('change', onModeChange); }
        else if (mq.addListener) { mq.addListener(onModeChange); }
        window.addEventListener('resize', function () {
          if (!isMobile()) positionDesktop(current);
        });

        setActive(0, false);
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
